import React from 'react';
import { tabs } from '../SalaryUtil.js';
import LinkTab from '../../../../common/tab/TabNav.js';

import 'moment-timezone'
import NewOccasionalSalaryForDates from './NewOccasionalSalaryForDates.js';
import MyCalendar from '../../../../common/calendar/MyCalendar.js';


function OccasionalSalaryCalendar() {

    const enrich = (response) => {
        const events = [];
        // console.log(response);
        response.data.map((occ) =>
            events.push({
                id: occ.publicId,
                title: occ.name,
                start: new Date(occ.date),
                end: new Date(occ.date),
                hexColor: '81d8d0',
                allDay: 'true'
            }));
        // console.log(events);
        return events;
    }

    return (
        <>
            <LinkTab tabs={tabs} index={0} />
            <MyCalendar
                enrich={(response) => enrich(response)}
                newEventApi={'/api/occasionalsalaries'}
                newEventDialogTitle={'Új alkalmi fizetés'}
                newEventDialogContent={(startDate, endDate, refresh, close) => <NewOccasionalSalaryForDates start={startDate} end={endDate} refresh={refresh} close={close} />} />
        </>
    );

}

export default OccasionalSalaryCalendar;